angular.module('tf.strategy')
    .service('ticketService', ["$uibModal", "$q", "simpleModalService", "ticketUtil", "$http", ticketService]);

/** @ngInject */
function ticketService($uibModal, $q, simpleModalService, ticketUtil, $http) {

    function openTicket(whatIf, portfolioId, portfolioType, accountName, today, advisorMode, orderCreatedCallback) {
        // Unset the TMC on a copy of the object
        // The issue is that we are overloading TMC to mean 'is a locked strategy' and is a TMC
        if (whatIf.trades.length < 2) {
            whatIf = Object.assign({}, whatIf);
            whatIf.tmc = false;
        }

        if (whatIf.tmc) {
            var invalidTmcMsg = ticketUtil.validateTradesForTmc(whatIf.trades, false);
            if (invalidTmcMsg != null) {
                simpleModalService.alert(invalidTmcMsg);
                return $q.reject();
            }
        }

        var modalInstance = $uibModal.open({
            templateUrl: 'app/portfolio/templates/ticket/ticket.tpl.html',
            controller: 'ticketCtrl as ctrl',
            size: 'lg',
            backdrop: 'static',
            resolve: {
                portfolioId: function () {
                    return portfolioId
                },
                portfolioType: function () {
                    return portfolioType;
                },
                portfolioName: function () {
                    return accountName;
                },
                orderCreatedCallback: function () {
                    return orderCreatedCallback;
                },
                whatIf: function () {
                    return whatIf;
                },
                today: function () {
                    return today;
                },
                isAdviserMode: function () {
                    return advisorMode;
                }
            }
        });
        return modalInstance.result;
    }

    function shrinkTrade(trade) {
        var smaller = {
            id: trade.id,
            i: trade.include,
            m: trade.manual,
            c: trade.code,
            q: +trade.quantity,
            t: trade.tradeDate,
            p: trade.price

        };
        return smaller;
    }

    function shrinkPosition(position) {
        var smaller = angular.copy(position);
        if (smaller.i === true) {
            delete smaller.i;
        }
        if (smaller.m === false) {
            delete smaller.m;
        }
        return smaller;
    }

    function generateMarginData(whatIf, portfolio) {
        // create a temporary what if so everything else works as if it were a what if (but with no trades)
        if (whatIf == null) {
            whatIf = {trades: [], positions: []};
        }

        var cashCollateral = portfolio.eodMarginSummary.cashCollateral;
        var equityCollateral = portfolio.eodMarginSummary.equityCollateral.map(function (value) {
            return {
                id: value.id,
                issuer: value.issuer,
                quantity: value.quantity,
                specificCover: value.specificCover,
                price: value.price,
                available: value.available,
                totalCost: value.totalCost
            };
        });

        var equityTrades = whatIf.trades.filter(function (t) {
            return t.code.length === 3
        }).map(function (t) {
            return {
                id: t.id,
                issuer: t.code,
                specificCover: false,
                quantity: t.quantity,
                available: t.quantity,
                price: t.price,
                totalCost: 0
            };
        });

        var trades = whatIf.trades.filter(function (t) {
            return t.code.length === 6;
        }).map(shrinkTrade);

        return {
            id: portfolio.id,
            scenarioDefinitions: null,
            positions: portfolio.positions.map(shrinkPosition),
            pinnedTrades: [],
            trades: trades,
            marginMultiplier: portfolio.marginMultiplier,
            limitMultiplier: portfolio.limitMultiplier,
            marginSchedule: portfolio.marginSchedule,
            etoBrokerageSchedule: portfolio.etoBrokerageSchedule,
            lepoBrokerageSchedule: portfolio.lepoBrokerageSchedule,
            equityBrokerageSchedule: portfolio.equityBrokerageSchedule,
            eodEtoLedger: portfolio.eodEtoLedger,
            currentEtoLedger: portfolio.currentEtoLedger,
            eodEquityLedger: portfolio.eodEquityLedger,
            currentEquityLedger: portfolio.currentEquityLedger,
            eodCmaBalance: portfolio.eodCmaBalance,
            currentCmaBalance: portfolio.currentCmaBalance,
            cashCollateral: cashCollateral,
            equityCollateral: equityCollateral,
            equityTrades: equityTrades,
            equityPositions: portfolio.equityPositions,
            scratch: portfolio.scratch
        };
    }

    function calculateMargin(whatIf, portfolio) {
        var marginData = generateMarginData(whatIf, portfolio);
        return requestMarginResult(marginData);
    }

    function requestMarginResult(marginData) {
        var req = {
            method: 'POST',
            url: '/tradefloor/api/margin/current',
            headers: {
                'Content-Type': 'application/json',
            },
            data: JSON.stringify(marginData),
            transformRequest: []
        };

        return $http(req).then(function (res) {
            return res.data
        })
    }

    function barColour(percent) {
        percent = Math.min(percent, 1);
        return "hsl(" + Math.round(120 * (1 - percent)) + ", 70%, 45%)";
    }

    function calculateChangeSummary(marginSummary) {
        var baseMargin = marginSummary.currentMarginSummary;
        var whatIfMargin = marginSummary.whatIfSummary;

        var newChangeSummary = {
            costOfTrade: whatIfMargin.costOfTrades,
            premiumChange: whatIfMargin.premiumMargin - baseMargin.premiumMargin,
            brokerage: -(whatIfMargin.brokerage + whatIfMargin.brokerageTax),
            brokerageTax: whatIfMargin.brokerageTax,
            fees: -(whatIfMargin.fees + whatIfMargin.feesTax),
            feesTax: whatIfMargin.feesTax,
            changeInMargin: whatIfMargin.clientMargin - baseMargin.clientMargin,
            changeInScan: whatIfMargin.scanRisk - baseMargin.scanRisk,
            addMargin: (whatIfMargin.clientMargin - whatIfMargin.totalMargin) - (baseMargin.clientMargin - baseMargin.totalMargin),
            changeInIC: whatIfMargin.interCommodityConcession - baseMargin.interCommodityConcession,
            netEffect: 0,
            currentShortage: baseMargin.shortageExcess - baseMargin.lepoMtm,
            whatIfShortage: whatIfMargin.shortageExcess,
            nlv: marginSummary.nlv,
            lepoMtm: whatIfMargin.lepoMtm,
            utilisation: whatIfMargin.utilisation,
            utilisationPct: whatIfMargin.utilisation * 100,
            utilisationClamped: Math.min(100, whatIfMargin.utilisation * 100),
            utilisationLevel: barColour(whatIfMargin.utilisation)
        };

        newChangeSummary.totalMargin = newChangeSummary.changeInMargin + newChangeSummary.addMargin;
        newChangeSummary.changeInCollateral = whatIfMargin.collateralBalance - baseMargin.collateralBalance;
        newChangeSummary.netEffect = whatIfMargin.shortageExcess - baseMargin.shortageExcess;
        newChangeSummary.shortageAdjustment = (whatIfMargin.shortageExcess - whatIfMargin.lepoMtm) - (newChangeSummary.netEffect + newChangeSummary.currentShortage);
        newChangeSummary.whatIfShortage = whatIfMargin.shortageExcess;

        if (Math.abs(newChangeSummary.shortageAdjustment) < 0.01) {
            newChangeSummary.shortageAdjustment = 0;
        }

        if (Math.abs(newChangeSummary.lepoMtm) < 0.01) {
            newChangeSummary.lepoMtm = 0;
        }

        if (Math.abs(newChangeSummary.addMargin) < 0.01) {
            newChangeSummary.addMargin = 0;
        }

        return newChangeSummary;
    }

    async function adviceTypes() {
        const response = await $http.get("/tradefloor/api/broker/advice");
        return response.data;
    }

    return {
        openTicket: openTicket,
        calculateMargin: calculateMargin,
        requestMarginResult: requestMarginResult,
        calculateChangeSummary: calculateChangeSummary,
        adviceTypes: adviceTypes
    }
}
